import { Spin } from "antd";
import React from "react";

const Loading = () => {
  return (
    <div className="container">
      <Spin />
    </div>
  );
};

export default Loading;
